const getCart = async () => {
  const resp = await fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = resp.json();
  return data;
};

document.addEventListener("DOMContentLoaded", () => {
  const accept_elite = document.querySelector("#accept_policy");

  if (accept_elite) {
    accept_elite.addEventListener("click", async () => {
      const id = accept_elite.value;

      const get_cart = await getCart();
      const matched_item = get_cart.items.find((item) => item.variant_id == id);

      if (matched_item) {
        const updates = { [id]: 1 };

        try {
          const response = await fetch(
            window.Shopify.routes.root + "cart/update.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ updates }),
            }
          );

          if (!response.ok) throw new Error("Failed to remove item from cart");

          const data = await response.json();
          alert("Elite Membership Product is already in the cart");
          window.location.href = "/cart";
        } catch (error) {
          console.error("Error removing item from cart:", error);
        }
      } else {
        if (accept_elite.checked) {
          // Add product to cart
          const formData = {
            items: [
              {
                id: +id, // Ensure this ID is dynamically replaced
                quantity: 1,
                properties: { _type: "hide" },
              },
            ],
          };

          try {
            const response = await fetch(
              window.Shopify.routes.root + "cart/add.js",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
              }
            );

            if (!response.ok) throw new Error("Failed to add item to cart");

            const data = await response.json();
            console.log("Item added to cart:", data);
          } catch (error) {
            console.error("Error adding item to cart:", error);
          }
        } else {
          // Remove product from cart
          const updates = { [id]: 0 }; // Proper syntax for dynamic object keys

          try {
            const response = await fetch(
              window.Shopify.routes.root + "cart/update.js",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ updates }),
              }
            );

            if (!response.ok)
              throw new Error("Failed to remove item from cart");

            const data = await response.json();
            console.log("Item removed from cart:", data);
          } catch (error) {
            console.error("Error removing item from cart:", error);
          }
        }
      }
    });
  } else {
    console.warn("Checkbox with ID 'accept_policy' not found.");
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const details_button = document.querySelectorAll(".cc-sites-access-button");

  details_button.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();

      const content = JSON.parse(item.dataset.content);

      // Generate the HTML for the popup
      const template = `
          <div class="cc-site-popup-block">
            <button class="cc-site-popup-close-button" onclick="closePopup()">
              <img src="https://cdn.shopify.com/s/files/1/0925/7290/files/close-button.png" class="img-responsive" />
            </button>
            <div class="cc-site-popup-content">
              <div class="cc-site-popup-logo">
                <img src="${content.logo}" class="img-responsive" />
              </div>
              <div class="cc-site-popup-list">
                <h3>${content.club.heading}</h3>
                <ul>
                  ${content.club.list
                    .map(
                      (item) => `
                      <li>
                        <img src="https://cdn.shopify.com/s/files/1/0925/7290/files/red-tick.png?v=1732415833" class="img-responsive" />
                        <span>${item}</span>
                      </li>`
                    )
                    .join("")}
                </ul>
              </div>
              <div class="cc-site-popup-list">
                <h3>${content.elite.heading}</h3>
                <ul>
                  ${content.elite.list
                    .map(
                      (item) => `
                      <li>
                        <img src="https://cdn.shopify.com/s/files/1/0925/7290/files/blue-tick.png?v=1732415833" class="img-responsive" />
                        <span>${item}</span>
                      </li>`
                    )
                    .join("")}
                </ul>
              </div>
            </div>
             <button class="cc-site-popup-close-button-text" onclick="closePopup()">Close</button>
          </div>
        `;

      // Append the popup to the body
      document.body.insertAdjacentHTML("afterbegin", template);
    });
  });
});

// Function to close the popup
function closePopup() {
  const popup = document.querySelector(".cc-site-popup-block");
  if (popup) {
    popup.remove();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const alreadyElite = document.querySelectorAll(".cc-already-elite-member");
  alreadyElite.forEach((item) => {
    item.addEventListener("click", async (e) => {
      e.preventDefault();
      alert("Already An Elite Member!");
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const getAllEliteProducts = document.querySelectorAll(
    ".cc-elite-product-api"
  );
  console.log("Add Elite Product")

  getAllEliteProducts.forEach((item) => {
    item.addEventListener("click", async (e) => {
      e.preventDefault();
      e.target.textContent = "Loading...";

       // if (typeof Shopify.customer === "undefined") {
       //      alert("Please login or Signup to add  Elite product to your cart.");
       //      return;
       //  }
      const id = e.target.dataset.id;

      const get_cart = await getCart();
      const matched_item = get_cart.items.find((item) => item.variant_id == id);

      if (matched_item) {
        const updates = { [id]: 1 };

        try {
          const response = await fetch(
            window.Shopify.routes.root + "cart/update.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ updates }),
            }
          );

          if (!response.ok) throw new Error("Failed to remove item from cart");

          const data = await response.json();
          console.log("Item removed from cart:", data);
          alert("Elite Membership Product is already in the cart");
          window.location.href = "/cart";
        } catch (error) {
          console.error("Error removing item from cart:", error);
        }
      } else {
        const formData = {
          items: [
            {
              id: +id, // Ensure `id` is a number
              quantity: 1,
              properties: { _type: "hide" },
            },
          ],
        };

        try {
          const response = await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            }
          );

          if (!response.ok) throw new Error("Failed to add item to cart");

          const data = await response.json();
          window.location.href = "/cart";
        } catch (error) {
          console.error("Error adding item to cart:", error);
          e.target.textContent = "Error, try again";
        }
      }
    });
  });
});

 


document.addEventListener("DOMContentLoaded", () => {
  const productSlider = document.querySelectorAll(".cc-products-slider");

  if (productSlider.length > 0) {
    productSlider.forEach((slider) => {
      new Splide(slider, {
        perPage: 3,
        gap: "26px",
        rewind: true,
        arrows: false,
        pagination: false,
        breakpoints: {
          1200: {
            perPage: 2,
          },
          800: {
            type: "loop",
            padding: "15%",
            perPage: 1,
          },
        },
      }).mount();
    });
  }

  const sitesSlider = document.querySelectorAll(".cc-sites-slider");

  if (sitesSlider.length > 0) {
    sitesSlider.forEach((slider) => {
      new Splide(slider, {
        perPage: 4,
        gap: "24px",
        rewind: true,
        arrows: false,
        pagination: false,
        breakpoints: {
          1200: {
            perPage: 2,
          },
          800: {
            type: "loop",
            padding: "15%",
            perPage: 1,
          },
        },
      }).mount();
    });
  }
});
// Function to compare and hide buttons
function hideEmptyOptions() {
    // Select all input elements and buttons within the parent container
    const inputs = document.querySelectorAll('.inner input.hide-empty');
    const buttons = document.querySelectorAll('.inner button.v-id');

    // Iterate through each button
    buttons.forEach(button => {
        const buttonValue = button.value; // Get button value (v-id value)

        // Find the matching input element based on data-title
        const matchingInput = Array.from(inputs).find(input => input.getAttribute('data-title') === buttonValue);

        // If matching input is found, check if data-m or data-e is empty
        if (matchingInput) {
            const dataM = matchingInput.getAttribute('data-m');
            const dataE = matchingInput.getAttribute('data-e');

            // If either data-m or data-e is empty, hide the button
            if (!dataM || !dataE) {
                button.style.display = 'none'; // Hide the button
            }
        }
    });
}

// Call the function to process the elements
hideEmptyOptions();
